const accessoryCategoryNames = {
  adapteri: "Адаптери",
  bzvucnici: "Bluetooth звучници",
  dodatocizakola: "Додатоци за кола",
  ggluvcinja: "Гејминг глувчиња",
  gpodlogi: "Подлоги за глувче",
  gslusalki: "Гејминг слушалки",
  gtastaturi: "Гејминг тастатури",
  gzvucnici: "Гејминг звучници",
  kabli: "Кабли",
  polnaci: "Полначи",
  slusalki: "Слушалки",
  wpolnac: "Wireless полначи",
};

export const getCategorySeo = ({ section, category }) => {
  const normalizedSection = String(section || "").trim().toLowerCase();
  const normalizedCategory = String(category || "").trim();
  const canonicalPath = `/${normalizedSection}/${encodeURIComponent(
    normalizedCategory
  )}`;

  if (normalizedSection === "telefoni") {
    return {
      canonicalPath,
      title: `${normalizedCategory} мобилни телефони | Buzz Mobile`,
      description: `Погледнете ја понудата на ${normalizedCategory} мобилни телефони во Buzz Mobile.`,
      categoryName: normalizedCategory,
    };
  }

  const categoryName =
    accessoryCategoryNames[normalizedCategory.toLowerCase()] ||
    normalizedCategory;

  return {
    canonicalPath,
    title: `${categoryName} | Buzz Mobile`,
    description: `Погледнете ја понудата на ${categoryName.toLowerCase()} во Buzz Mobile.`,
    categoryName,
  };
};
